import {
  StyledRadio,
  StyledHelpIcon
} from "../../../../../components/shared/SharedStyles/SharedStyles";
import IconButton from "@mui/material/IconButton";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  Grid,
  Stack,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from "@mui/material";
import BloodPressure from "assets/reading icons/Reading - Blood Pressure.svg";
import Glucose from "assets/reading icons/Reading - Glucose.svg";
import Oxygen from "assets/reading icons/Reading - Oxygen.svg";
// TODO: add svg icon for spirometry
import Temperature from "assets/reading icons/Reading - Temperature.svg";
import Weight from "assets/reading icons/Reading - Weight.svg";
import Button from "components/shared/Button/Button";
import Tooltip from "@mui/material/Tooltip";
import React, { ChangeEvent, useContext, useState, useEffect } from "react";
import { GlobalContext } from "../../../../../context/Provider";
import { ReadingContextInterface } from "../../../../../context/initialState/Readings";
import { useTranslation } from "react-i18next";
import { EncounterTimerDisplay } from "components/shared/EncounterTimer/EncounterTimer";
import {
  memberContextInterface,
  memberObject
} from "context/initialState/Member";
import API from "api";
import { useNavigate } from "react-router-dom";
import {
  AddEncounterEvent,
  formatSpirometry,
  toLocalTime
} from "helpers/variables";
import {
  MeasurementHead,
  BoldText,
  BasicDetails,
  BasicText,
  StyledText,
  UniqueDetails,
  StyledLeftGrid,
  BoldDetailsText,
  StyledFormControlLabel,
  StyledTextField,
  BMIContainer,
  BMISliderContainer,
  BMISliderLabel,
  BMISliderBarBlue,
  BMISliderBarGreen,
  BMISliderBarYellow,
  BMISliderBarOrange,
  BMISliderBarPink,
  BMISliderBarRed,
  BMISliderSelectorStack,
  BMISliderSpacer,
  BMIGrid,
  FlagGrid,
  FlaggedContainer,
  StyledFlagOutlinedIcon,
  IconImage
} from "./Attributes.styles";
import Session from "helpers/session";
import { StyledLineGraph } from "views/Provider/Subviews/Reports/Charts/LineGraph";
import SimpleGrid, {
  BodyProps,
  CellProps
} from "components/shared/SimpleGrid/SimpleGrid";
import { NotesObject } from "context/initialState/Notes";
import moment from "moment";
import { useParams } from "react-router-dom";
import { COORDINATOR } from "helpers/appConstants";
import { ActivityReadingChart } from "./ActivityReadingChart";
import InvalidateModal from "components/shared/InvalidateModal/InvalidateModal";

interface AttributeProps {
  type: string;
  memberId: string;
}
// TODO: Create icons for spirometry and activity
const getIcon = (type: string) => {
  switch (type) {
    case "Blood Pressure":
      return BloodPressure;
    case "Blood Glucose":
      return Glucose;
    case "Oxygen Saturation":
      return Oxygen;
    case "Spirometry":
      return Oxygen /*Spirometry*/;
    case "Temperature":
      return Temperature;
    case "Weight":
      return Weight;
    case "activity":
      return BloodPressure; /*Activity*/
  }
};

export default function Attributes({ type, memberId }: AttributeProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    member,
    readings,
    readingsDispatch,
    notifications,
    notificationsDispatch,
    encounterTimer,
    provider
  } = useContext(GlobalContext);
  const [flagSelect, setFlagSelect] = useState<boolean>();
  const [note, setNote] = useState<string>("");
  const [noteTable, setNoteTable] = useState<NotesObject[]>([]);
  const spirReading = readings ? formatSpirometry(readings) : null;
  const [isBreach, setIsBreach] = useState<boolean>(false);
  const [invalidateOpen, setInvalidateOpen] = useState(false);
  const readingNoteTableHeaders: CellProps[] = [
    { content: "Time", align: "left" },
    { content: "Note", align: "center" }
  ];
  const { readingId } = useParams<{ readingId: string }>();
  const isProvider =
    provider?.loggedInClient?.roles?.split(",").includes("Provider") ?? false;

  const handleSpirometryReading = () => {
    let spirData: any = [];
    const points = spirReading?.Points ? spirReading.Points : [];
    const fvcGraph = spirReading?.FVCExGraph ? spirReading.FVCExGraph : [];
    for (let i = 0; i < points.length; i++) {
      spirData.push({
        name: ``,
        "Flow(L/s)": points[i],
        "Max Flow(L/s)": fvcGraph[i]
      });
    }
    return spirData;
  };
  const handleRadioSelect = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === "rad-yes") {
      setFlagSelect(true);
    } else {
      setFlagSelect(false);
    }
  };

  const handleNoteChange = (event: ChangeEvent<HTMLInputElement>) => {
    setNote(event.target.value);
  };

  const sendNote = () => {
    const stockEncounter = {
      coordinatorId: Session.crackCookieUserId("coordinator"),
      coordinatorName: Session.crackCookieUsername("coordinator"),
      memberId: member?.current.id,
      memberName: member?.current.username,
      duration: 1,
      escalatedDuration: 1,
      actions: []
    };
    const duration = encounterTimer?.current?.duration ?? 0;
    if (isBreach) {
      if (flagSelect) {
        const newNote = {
          memberId: member?.current.id || "",
          authorId: Session.crackCookieUserId("coordinator"),
          readingId: readings?.id || "",
          authorName: Session.crackCookieUsername("coordinator"),
          content: note || "Reading reviewed.",
          type: "action"
        };
        API.kore.notes
          .create(newNote, Session.crackCookieToken("coordinator"))
          .then((noteRet) => {})
          .catch((err) => console.log(err));
        const encounterEvent = AddEncounterEvent(
          "intervention",
          `${readings?.type},${readings?.id}` || ""
        );
        Session.updateSessionEncounter(
          window.sessionStorage.getItem("encounter") ||
            Session.encrypt(JSON.stringify(stockEncounter)),
          encounterEvent,
          duration.toString() || ""
        );
      } else {
        const newNote = {
          memberId: member?.current.id || "",
          authorId: Session.crackCookieUserId("coordinator"),
          readingId: readings?.id || "",
          noticeId: notifications?.currentNotification?._id || "",
          authorName: Session.crackCookieUsername("coordinator"),
          content: note || "Reading reviewed and acknowledged.",
          type: "action"
        };
        API.kore.notes
          .create(newNote, Session.crackCookieToken("coordinator"))
          .then((noteRet) => {
            notificationsDispatch({
              type: "FILTER_ACKNOWLEDGED",
              payload: notifications?.currentNotification?._id || ""
            });
            notificationsDispatch({
              type: "UPDATE_COUNT",
              payload: notifications?.itemsCount
                ? notifications?.itemsCount - 1
                : notifications?.itemsCount
            });
          })
          .catch((err) => console.log(err));
        const encounterEvent = AddEncounterEvent(
          "intervention",
          `${readings?.type},${readings?.id}` || ""
        );
        Session.updateSessionEncounter(
          window.sessionStorage.getItem("encounter") ||
            Session.encrypt(JSON.stringify(stockEncounter)),
          encounterEvent,
          duration.toString() || ""
        );
      }
    } else {
      const newNote = {
        memberId: member?.current.id || "",
        authorId: Session.crackCookieUserId("coordinator"),
        readingId: readings?.id || "",
        authorName: Session.crackCookieUsername("coordinator"),
        content: note || "Reading reviewed.",
        type: "action"
      };
      API.kore.notes
        .create(newNote, Session.crackCookieToken("coordinator"))
        .then((noteRet) => {})
        .catch((err) => console.log(err));
      const encounterEvent = AddEncounterEvent(
        "readings review",
        `${readings?.type},${readings?.id}` || ""
      );
      Session.updateSessionEncounter(
        window.sessionStorage.getItem("encounter") ||
          Session.encrypt(JSON.stringify(stockEncounter)),
        encounterEvent,
        duration.toString() || ""
      );
    }
  };

  const handleNoteSubmission = () => {
    sendNote();
    navigate(`/patient/notes/${member?.current.id}`);
  };

  const calculatedBMI = (
    weight: number | undefined,
    member: memberContextInterface | undefined
  ) => {
    let pounds = weight || 0;
    let feet = member?.current.height?.feet || 0;
    let inches = member?.current?.height?.inches || 0;
    let mass = pounds / 2.205; // in kelograms
    let size = (feet * 12 + inches) / 39.37; // in meters
    return mass / (size * size);
  };
  const calculatedWidth = (
    weight: number | undefined,
    member: memberContextInterface | undefined
  ) => {
    const res = (calculatedBMI(weight, member) - 15) / 30 - 0.0533;
    return res * 100;
  };
  const labelBMI = () => {
    // const BMI = calculatedBMI(readings?.metrics?.weight, member).toFixed(2);
    const BMI = calculatedBMI(readings?.metrics?.weight, member);
    if (!Number.isFinite(BMI)) {
      return "No Data";
    }
    let label = "";
    if (BMI === 0) {
      label = "No Data";
    } else if (BMI < 18.5) {
      label = "Under Weight";
    } else if (BMI < 25) {
      label = "Healthy Weight";
    } else if (BMI < 30) {
      label = "Pre-Obese";
    } else if (BMI < 200) {
      label = "Obese";
    }
    return label;
  };

  const dressedReading = (reading: ReadingContextInterface | undefined) => {
    switch (reading?.type) {
      case "bp":
        return (
          <>
            <BasicText>
              {reading?.metrics?.systolic}/{reading?.metrics?.diastolic}
            </BasicText>
            <StyledText>mmHg</StyledText>
            <BasicText>({reading?.metrics?.pulse} </BasicText>
            <StyledText>bpm</StyledText>)
          </>
        );
      case "bgl":
        return (
          <>
            <BasicText>{reading?.metrics?.glucose}</BasicText>
            <StyledText>mg/dL</StyledText>
          </>
        );
      case "spo2":
        return (
          <>
            <BasicText>{reading?.metrics?.spo2}</BasicText>
            <StyledText>%</StyledText>
            <BasicText>({reading?.metrics?.pulse} </BasicText>
            <StyledText>bpm</StyledText>)
          </>
        );
      case "temp":
        return (
          <>
            <BasicText>{reading?.metrics?.temp}</BasicText>
            <StyledText>{reading?.metrics?.unit}</StyledText>
          </>
        );
      case "spir":
        return (
          <>
            <BasicText>{spirReading?.FVC}</BasicText>
            <StyledText>FVC</StyledText>
            <BasicText>{spirReading?.FEV1}</BasicText>
            <StyledText>FEV1</StyledText>
            <BasicText>
              {(
                (Number(spirReading?.FEV1) / Number(spirReading?.FVC)) *
                100
              ).toFixed(1)}
              %
            </BasicText>
            <StyledText>FEV1/FVC</StyledText>
          </>
        );
      case "hr":
        return (
          <>
            <BasicText>({reading?.metrics?.pulse} </BasicText>
            <StyledText>bpm</StyledText>)
          </>
        );
      case "wt":
        return (
          <>
            <BasicText>{reading?.metrics?.weight}</BasicText>
            <StyledText>LBS</StyledText>
          </>
        );
      case "activity":
        return (
          <>
            <BasicText>{reading?.metrics?.steps}</BasicText>
            <StyledText>STEPS</StyledText>
          </>
        );
      case "sleep":
        return (
          <>
            <BasicText>{reading?.metrics?.sleep}</BasicText>
            <StyledText>HRS</StyledText>
          </>
        );
      default:
        return <div>{t("u-no-data")}</div>;
    }
  };

  const getReadingNotes = () => {
    if (!readings?.id) return;

    API.kore.notes
      .getList(
        Session.crackCookieToken("coordinator"),
        `?sort_by=created_at&order=desc&filter=readingId:${readings.id}`
      )
      .then((notesArray) => {
        setNoteTable(notesArray ?? []);
      })
      .catch((err) => {
        setNoteTable([]);
      });
  };

  const generateList = (rawList: NotesObject[]): BodyProps[] => {
    return rawList.map((item) => {
      return {
        cells: [
          {
            content:
              moment(toLocalTime(item.createdAt)).format("MMM DD HH:mm") || "",
            align: "left"
          },
          { content: item.content || "", align: "left" }
        ]
      };
    });
  };
  useEffect(() => {
    if (!readings?.id) return;

    API.kore.notifications
      .getList(
        Session.crackCookieToken("coordinator"),
        `linkedReading:${readings.id}`
      )
      .then((res) => {
        const unacknowledgedNotif = res?.items?.find((item: any) => item.acknowledged === false);
        setIsBreach(!!unacknowledgedNotif);
        notificationsDispatch({
          type: "UPDATE_CURRENT",
          payload: unacknowledgedNotif || null
        });
      })
      .catch(console.error);
    window.scrollTo(0, 0);
    getReadingNotes();
  }, [readings?.id]);

  useEffect(() => {
    if (readings?.id) return;
    if (!readingId) return;

    API.kore.readings
      .getSingleReading(
        readingId,
        Session.crackCookieToken(COORDINATOR)
      )
      .then((reading) => {
        readingsDispatch({
          type: "UPDATE_READING",
          payload: reading
        });
      })
      .catch(console.error);
  }, [readingId, readings?.id]);

  return (
    <Grid container>
      <Grid item xs={2} sm={2} md={2} lg={0.7} />
      <Grid item xs={9} sm={9} md={9} lg={11}>
        <Box
          sx={{
            overflow: "auto",
            position: "fixed",
            top: 250,
            bottom: 68,
            left: 320,
            right: 110
          }}
        >
          <EncounterTimerDisplay/>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              boxSizing: "border-box",
              paddingRight: 4,
              paddingBottom: 2,
            }}
          >
            <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
              <IconImage src={getIcon(type)} />
              <MeasurementHead>{`${t(
                `u-${type.toLowerCase().replace(" ", "-")}`
              )} ${t("u-measurement-details")} ${toLocalTime(
                readings?.measuredAt
              )}`}</MeasurementHead>
            </Stack>

            {isProvider && (
              <Button
                variant="warning"
                height="48px"
                onClick={() => setInvalidateOpen(true)}
              >
                Invalidate
              </Button>
            )}
          </Box>
          <BasicDetails>
            <Stack spacing={1} direction="row">
              {dressedReading(readings)}
            </Stack>
          </BasicDetails>
          <UniqueDetails>
            <Grid container minWidth={800}>
              <StyledLeftGrid item md={12} lg={12}>
                <Grid container>
                  <Grid item lg={2.5} />
                  <Grid item md={4} lg={3}>
                    <BoldDetailsText>{t("u-member-details")}</BoldDetailsText>
                    <br />
                    <div style={{ paddingLeft: "24px" }}>
                      <BoldDetailsText>{`${t("u-phone")}:`}</BoldDetailsText>
                      <BoldDetailsText>{`${t(
                        "u-email-address"
                      )}`}</BoldDetailsText>
                      <BoldDetailsText>{`${t(
                        "u-preferred-language"
                      )}:`}</BoldDetailsText>
                      <BoldDetailsText>{`${t("u-site")} ${t(
                        "u-location"
                      )}:`}</BoldDetailsText>
                    </div>
                    <br />
                    <BoldDetailsText>{t("u-device-details")}</BoldDetailsText>
                    <br />
                    <div style={{ paddingLeft: "24px" }}>
                      <BoldDetailsText>{`${t("u-name")}:`}</BoldDetailsText>
                      <BoldDetailsText>{`${t("u-serial")}:`}</BoldDetailsText>
                      <BoldDetailsText>{`${t("u-address")}:`}</BoldDetailsText>
                    </div>
                  </Grid>
                  <Grid item md={8} lg={6.5}>
                    <br />
                    <br />
                    <BasicText>{member?.current.phone || "-"}</BasicText>
                    <BasicText>{member?.current.email || "-"}</BasicText>
                    <BasicText>{member?.current.language || "-"}</BasicText>
                    <BasicText>{member?.current.site || "-"}</BasicText>
                    <br />
                    <br />
                    <br />
                    <BasicText>
                      {readings?.metrics?.description || "-"}
                    </BasicText>
                    <BasicText>{readings?.metrics?.imei || "-"}</BasicText>
                    <BasicText>
                      {readings?.metrics?.macAddress || "-"}
                    </BasicText>
                  </Grid>
                </Grid>
              </StyledLeftGrid>
            </Grid>
          </UniqueDetails>

          {type === "Weight" && (
            <BMIContainer>
              <BoldDetailsText>{`BMI ${t("u-chart")}:`}</BoldDetailsText>
              <BasicText>{t("s-enter-height")}</BasicText>
              <BMIGrid container>
                <Grid item xs={2} />
                <Grid item xs={6}>
                  <BMISliderContainer>
                    <BMISliderSelectorStack direction={"row"}>
                      <BMISliderSpacer
                        sx={{
                          width: `${calculatedWidth(
                            readings?.metrics?.weight,
                            member
                          )}%`
                        }}
                      />
                      <LocationOnIcon fontSize="large" />
                    </BMISliderSelectorStack>
                  </BMISliderContainer>
                  <BMISliderContainer>
                    <Stack direction={"row"}>
                      <BMISliderBarBlue></BMISliderBarBlue>
                      <BMISliderBarGreen></BMISliderBarGreen>
                      <BMISliderBarYellow></BMISliderBarYellow>
                      <BMISliderBarOrange></BMISliderBarOrange>
                      <BMISliderBarPink></BMISliderBarPink>
                      <BMISliderBarRed></BMISliderBarRed>
                    </Stack>
                  </BMISliderContainer>
                  <BMISliderContainer>
                    <Stack direction={"row"}>
                      <BMISliderLabel>20</BMISliderLabel>
                      <BMISliderLabel>25</BMISliderLabel>
                      <BMISliderLabel>30</BMISliderLabel>
                      <BMISliderLabel>35</BMISliderLabel>
                      <BMISliderLabel>40</BMISliderLabel>
                    </Stack>
                  </BMISliderContainer>
                </Grid>
                <Grid item xs={1.5} />
                <Grid item xs={2.5}>
                  <BoldDetailsText>{`BMI ${calculatedBMI(
                    readings?.metrics?.weight,
                    member
                  ).toFixed(2)}, ${labelBMI()}`}</BoldDetailsText>
                </Grid>
              </BMIGrid>
            </BMIContainer>
          )}
          {type === "Spirometry" && (
            <BasicDetails>
              <Stack spacing={3} direction="row">
                <Stack direction="row">
                  <BoldText>FVC, L:</BoldText>
                  <BasicText>{spirReading?.FVC}</BasicText>
                </Stack>
                <Stack direction="row">
                  <BoldText>FEV1, L:</BoldText>
                  <BasicText>{spirReading?.FEV1}</BasicText>
                </Stack>
                <Stack direction="row">
                  <BoldText>FEV1/FVC%:</BoldText>
                  <BasicText>
                    {(
                      (Number(spirReading?.FEV1) / Number(spirReading?.FVC)) *
                      100
                    ).toFixed(1)}
                    %
                  </BasicText>
                </Stack>
              </Stack>
              <Stack>
                <StyledLineGraph
                  data={handleSpirometryReading()}
                  chart="spir"
                />
              </Stack>
            </BasicDetails>
          )}
          {type === "Blood Pressure" && (
            <BasicDetails>
              <Stack spacing={2} direction="row">
                <BoldText>{`${t("u-cuff-dressed")}:`}</BoldText>
                <BasicText>{t("u-ok")}</BasicText>
              </Stack>
              <Stack spacing={2} direction="row">
                <BoldText>{`${t("u-irregular-pulse")}:`}</BoldText>
                <BasicText>{t("u-not-detected")}</BasicText>
              </Stack>
              <Stack spacing={2} direction="row">
                <BoldText>{`${t("u-movement-during-measurement")}:`}</BoldText>
                <BasicText>{t("u-not-detected")}</BasicText>
              </Stack>
              <Stack spacing={2} direction="row">
                <BoldText>{`${t("u-pulse-range-inclusion")}:`}</BoldText>
                <BasicText>{t("u-within")}</BasicText>
              </Stack>
            </BasicDetails>
          )}
          {noteTable.length > 0 && (
            <SimpleGrid
              headers={readingNoteTableHeaders}
              body={generateList(noteTable)}
            />
          )}
          {type === "activity" && (
            <BasicDetails>
              <ActivityReadingChart reading={readings} />
            </BasicDetails>
          )}
          <div>
            <StyledFormControlLabel
              label={t("s-add-new-comment")}
              control={
                <StyledTextField
                  placeholder={t("s-add-new-comment")}
                  multiline
                  minRows={4}
                  maxRows={4}
                  onChange={handleNoteChange}
                  value={note}
                />
              }
              labelPlacement="top"
            />
            <Grid container minWidth={600}>
              {!isBreach && <Grid item md={10} lg={10} />}
              {isBreach && (
                <Tooltip title={t("s-flagged-tooltip")} arrow>
                  <IconButton>
                    <StyledHelpIcon fontSize="medium" />
                  </IconButton>
                </Tooltip>
              )}
              {isBreach && <Grid item md={0.1} lg={0.1} />}
              {isBreach && (
                <FlagGrid item md={1} lg={1}>
                  <FlaggedContainer>
                    <StyledFlagOutlinedIcon></StyledFlagOutlinedIcon>
                  </FlaggedContainer>
                </FlagGrid>
              )}
              {isBreach && (
                <FormControl>
                  <RadioGroup row>
                    <StyledRadio>
                      <FormControlLabel
                        value="Yes"
                        control={
                          <Radio
                            id="rad-yes"
                            onChange={handleRadioSelect}
                            checked={flagSelect}
                          />
                        }
                        label={"Keep Active"}
                      />
                    </StyledRadio>
                    <StyledRadio>
                      <FormControlLabel
                        value="No"
                        control={
                          <Radio
                            id="rad-no"
                            onChange={handleRadioSelect}
                            checked={!flagSelect}
                          />
                        }
                        label={"Clear Notification"}
                      />
                    </StyledRadio>
                  </RadioGroup>
                </FormControl>
              )}
              <Grid item lg={2}>
                <Button
                  variant="success"
                  height="48px"
                  onClick={handleNoteSubmission}
                >
                  {t("u-save")}
                </Button>
              </Grid>
              <Grid item md={8} lg={8}></Grid>
            </Grid>
          </div>
        </Box>
      </Grid>
      <Grid xs={1} sm={1} md={1} lg={0.3} />
      {isProvider && (
        <InvalidateModal
          open={invalidateOpen}
          onClose={() => setInvalidateOpen(false)}
          readingId={readings?.id}
          onConfirm={async (reason) => {
            if (!readings?.id) return;
            await API.kore.readings.invalidate(readings.id, { invalid: true, reason }, Session.crackCookieToken("provider"));
            navigate(`/patient/history/${type.toLowerCase().replace(" ", "")}/list/${memberId}`);
          }}
        />
      )}
    </Grid>
  );
}
